import React from "react";
import Image from "../../Assets/Images/default-image.png";
import { Avatar, Typography, Grid } from "@material-ui/core";
const NewReqAvatar = ({ classes, RestData, setRestData }) => {
  return (
    <>
      <Grid container className={classes.dFlex}>
        <Grid item xs={4} md={4}>
          <Avatar
            src={Image}
            alt={RestData.restName}
            className={classes.avatarStyles}
          />
        </Grid>
        <Grid item xs={8} md={8} className={classes.fWrap}>
          <Typography variant="h4">{RestData.restName}</Typography>
        </Grid>
      </Grid>
    </>
  );
};

export default NewReqAvatar;
